import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#EB2961" }}>Problem</span>
            </h2>
            <p>
              The client needed a website that is not only easy to use but that
              also has all the functions and features that models, photographers
              and other talents would need for a successful experience.
              Efficiency and functionality were two aspects we knew we couldn’t
              compromise on for Talpool.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/talpool/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1081}
              height={616}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
